import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import { getImageProps } from 'app/utilities/ImageProps';


function Linkes({epiData, context, pageType, detailsProdact}) {
    
    let linksData = [];
    let titleText = '';
    let imageGuides = null;
    
    const sourceData = pageType === 'equipments' 
    ? epiData.itemsGuides 
    : detailsProdact?.itemsGuides?.expandedValue;

    linksData = sourceData?.map((guideItem) => ({
        imageGuides: getImageProps(guideItem.imageGuides, context),
        titleGuides: guideItem.titleGuides?.value,
        itemsGuides: guideItem.linkesGuides?.expandedValue?.map((item) => ({
            linkText: item.linkText?.value,
            linkButton: item.linkButton?.value,
        }))
    })) || [];

    return (
        <div className='link-container'>
        <div className="guides-list">
            {linksData[0]?.imageGuides?.src && <Image src={linksData[0]?.imageGuides?.src} alt='image' />}
            <h2>{linksData[0]?.titleGuides}</h2>
            {linksData[0]?.itemsGuides?.map((item, index) => {
                return (
                    <div key={index} className="guide-link">
                        <a href={item.linkButton} >
                            {item.linkText}
                        </a>
                    </div>
                )
            })}
        </div>
    </div>
    );
}

const mapStateToProps = (state) => ({
    epiData: state.equipmentListPage.epiData
});

export default connect(mapStateToProps)(Linkes);
